import { AdBlock } from "../components/blocks/ad-block";
import { primaryCTAType } from "../types";
import {
  generateStorefrontImage,
  VinoDataImage,
} from "../utils/generate-storefront-image";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_AdBlock";

const create = (data: {
  image: VinoDataImage;
  backgroundImageSmall: VinoDataImage;
  primaryCta: primaryCTAType;
  buttonPosition: string;
  countdownTimer: string;
  shortText: string;
  longText: string;
  hubspotFormId: string;
  internalName: string;
  layout: string;
}): JSX.Element => {
  const transformedData = {
    backgroundImage: generateStorefrontImage(data.image),
    backgroundImageSmall: generateStorefrontImage(data.backgroundImageSmall),
    imageURLs: {
      desktop: data?.image?.url,
      mobile: data?.backgroundImageSmall?.url,
    },
    primaryCta: data.primaryCta,
    buttonPosition: data.buttonPosition,
    countdownTimer: data.countdownTimer,
    shortText: data.shortText,
    longText: data.longText,
    hubspotFormId: data.hubspotFormId,
    layout: data.layout,
  };

  return <AdBlock {...transformedData} />;
};

export default { test, create };
